"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _PhysicalProperties = _interopRequireDefault(require("../PhysicalProperties"));

var _DigitalProperties = _interopRequireDefault(require("../DigitalProperties"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Estate = function Estate(_ref) {
  var logo = _ref.logo,
      properties = _ref.properties,
      socials = _ref.socials,
      company = _ref.company,
      text = _ref.text,
      path = _ref.path;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    component: "footer"
  }, /*#__PURE__*/_react["default"].createElement(_PhysicalProperties["default"], {
    logo: logo,
    properties: properties
  }), /*#__PURE__*/_react["default"].createElement(_DigitalProperties["default"], {
    company: company,
    socials: socials,
    text: text,
    path: path
  }));
};

Estate.defaultProps = {
  logo: {},
  socials: [],
  text: '',
  path: ''
};
Estate.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  logo: _propTypes["default"].object,
  properties: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].node)).isRequired,
  socials: _propTypes["default"].arrayOf(_propTypes["default"].string),
  company: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].node,
  path: _propTypes["default"].string
};
var _default = Estate;
exports["default"] = _default;